module.exports = __webpack_public_path__ + "img/damage_locations_pinpoint.f5a016bb.svg";